export const CREATE_WEDDING_APP_NAME = 'createwedding';
